import { gql } from '@apollo/client'
import { GuildFragment } from '@src/graphql/fragment/guild'
import { PageInfoFragment } from '@src/graphql/fragment/pageInfo'

export default gql`
  query GetGuilds($input: GetGuildsInput!, $type: GuildType!) {
    getGuildsByType(input: $input, guildType: $type) {
      pageInfo {
        ...PageInfo
      }
      guilds {
        ...Guild
      }
    }
  }

  ${GuildFragment}
  ${PageInfoFragment}
`
